const otpFormRu = {
  'otpForm': {
    'codeLabel': 'Код из смс',
    'sendNewSms': 'Запросить код повторно',
    'description': 'Введите код из СМС, отправленный на ваш номер {{phone}}',
    'resendCodeAfter': 'Отправить код повторно через',
    'confirm': 'Подтвердить',
    'errors': {
      'sms_auth_code_expired': 'Срок действия кода истек. Запросите новый',
      'sms_auth_code_invalid': 'Код введен неверно. Попробуйте еще',
      'sms_auth_code_many_attempts': 'Код недействителен. Запросите новый',
      'sms_auth_sms_not_sent': 'СМС не может быть отправлено из-за непредвиденной ошибки',
    },
  },
};

export default otpFormRu;
